









































import { DataProxy } from 'apollo-cache';
import * as R from 'ramda';
import Vue from 'vue';

import { Task } from '@/core/entity';

import { assignTaskFragment, listTaskQL, taskFragment } from './graphql';

import List from './List.vue';
import NewModal from './NewModal.vue';

export default Vue.extend({
  components: {
    'list-task': List,
    'modal-new': NewModal,
  },

  data() {
    return {
      isModalVisible: false,
      loading: false,
    };
  },

  methods: {
    handleAssignAuditor(args: { taskId: string; userId: string | null }) {
      const { taskId, userId } = args;
      if (taskId !== null && userId !== null) {
        this.$coreApp.task.assign(
          taskId,
          userId,
          this.presenter('Auditor assigned.', 'Unable to assign auditor'),
          { name: 'AssignTask_result', query: assignTaskFragment },
          this.updater,
        );
      }
    },

    handleCreate(args: { country: string; date: string }) {
      this.hideModal();

      this.$coreApp.task.create(
        args.country,
        args.date,
        this.presenter('Tasks created.', 'Unable to create tasks.'),
        { name: 'ListTaskPageTask', query: taskFragment },
        this.updater,
      );
    },

    handleUpdateNote(args: { taskId: string; note: string }) {
      this.$coreApp.task.update(
        args.taskId,
        { note: args.note },
        this.presenter('Note updated.', 'Unable to update note.'),
      );
    },

    hideModal() {
      this.isModalVisible = false;
    },

    presenter(success: string, failure: string) {
      return (
        err: Error | null,
        result: Task | Task[] | null,
        loading: boolean,
      ) => {
        this.loading = loading;
        if (err) {
          this.$message.error(`${failure} ${err.message}`);
        } else if (result !== null) {
          this.$message.success(success);
        }
      };
    },

    showModal() {
      this.isModalVisible = true;
    },

    updater(
      store: DataProxy,
      res: { data: { assignTask?: Task; newTasks?: Task[] } },
    ) {
      const data: { tasks: Task[] } | null = store.readQuery({
        query: listTaskQL,
      });

      if (res.data.assignTask) {
        const task = res.data.assignTask as Task;

        const idx = R.findIndex(R.propEq('id', task.id))(data!.tasks);
        if (idx !== -1) {
          const previous = data!.tasks[idx];
          data!.tasks = R.update(
            idx,
            {
              ...previous,
              ...task,
            },
            data!.tasks,
          );
        }
      } else if (res.data.newTasks) {
        const tasks: Task[] = res.data.newTasks;
        data!.tasks = R.concat(tasks, data!.tasks);
      }

      store.writeQuery({
        query: listTaskQL,
        data,
      });
    },
  },
});
